export default __webpack_public_path__ + "static/media/IMG.d58260e0.JPG";